module.exports = __webpack_public_path__ + "images/emoji/fireworks.26792c88d79b938d15ae.png";